/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Represents the different phases of a session.
 */ 
export enum SessionPhaseType {
    /**
     * The confirmation phase.
     */ 
    Confirmation = 0,
    /**
     * The student ready phase.
     */ 
    StudentReady = 1,
    /**
     * The pre-encounter phase.
     */ 
    PreEncounter = 2,
    /**
     * The encounter phase.
     */ 
    Encounter = 3,
    /**
     * The post-encounter phase.
     */ 
    PostEncounter = 4,
    /**
     * The intermission/break phase.
     */ 
    Intermission = 5,
    /**
     * The closing phase.
     */ 
    Closing = 6,
}
